import React from "react";
import { useTranslation } from "react-i18next";

import URL from "../../../../constant/URL";
import http from "../../../../http/http";
import LearningNoteStepState from "./LearningNoteStepState";
import useLoading from "../../../../hooks/useLoading";
import { useUserInfo } from "../../../../hooks";
import { secondsToMinutes } from "../../../../utils/utilityEtc";
import { TYPE } from "../../../../constant";
import useAmplitude from "../../../../hooks/useAmplitude";

const LearningNoteAnalysis = (props) => {
  const [list, setList] = React.useState({});
  const { info } = useUserInfo();
  const { t, i18n } = useTranslation();
  const { setAmplitudeLog } = useAmplitude();
  const [drillFlag, setDrillFlag] = React.useState(false);
  const { setLoading, clearLoading } = useLoading();

  const setStatus = (status, sort) => {
    let div;
    if (sort === "hide_t") {
      if (status === "BEFORE-LEARNING") {
        div = (
          <img
            className="state1"
            // src={`${process.env.PUBLIC_URL}/static/images/icon/ic_status_1_mo_pc.svg`}
            src={
              i18n.language === 'en'
                ? `${process.env.PUBLIC_URL}/static/images/icon/ic_status_1_mo_en.svg`
                : `${process.env.PUBLIC_URL}/static/images/icon/ic_status_1_mo_pc.svg`
            }
            alt=""
          />
          
        );
      } else if (status === "NOW-LEARNING") {
        div = (
          <img
            className="state2"
            height={info.channelCode === TYPE.CHANNEL.GLOBAL01 ? '38' : ''}
            src={
              i18n.language === 'en'
                ? `${process.env.PUBLIC_URL}/static/images/icon/ic_status_2_tv_th_eng.svg`
                : `${process.env.PUBLIC_URL}/static/images/icon/ic_status_2_mo.svg`
            }
            alt=""
          />
        );
      } else if (status === "COMPLETED-LEARNING") {
        div = (
          <img
            className="state3"
            height={info.channelCode === TYPE.CHANNEL.GLOBAL01 ? '38' : ''}
            src={
              i18n.language === 'en'
                ? `${process.env.PUBLIC_URL}/static/images/icon/ic_status_3_tv_th_eng.svg`
                : `${process.env.PUBLIC_URL}/static/images/icon/ic_status_3_mo.svg`
            }
            alt=""
          />
        );
      }
    } else {
      if (status === "BEFORE-LEARNING") {
        div = (
          <img
            className="state1"
            height={info.channelCode === TYPE.CHANNEL.GLOBAL01 ? '38' : ''}
            src={
              i18n.language === 'en'
                ? `${process.env.PUBLIC_URL}/static/images/icon/ic_status_1_tv_th_eng.svg`
                : `${process.env.PUBLIC_URL}/static/images/icon/ic_status_1_tv_th.svg`
            }
            alt=""
          />
        );
      } else if (status === "NOW-LEARNING") {
        div = (
          <img
            className="state2"
            src={
              i18n.language === 'en'
                ? `${process.env.PUBLIC_URL}/static/images/icon/ic_status_2_tv_th_eng.svg`
                : `${process.env.PUBLIC_URL}/static/images/icon/ic_status_2_tv_th.svg`
            }
            alt=""
          />
        );
      } else if (status === "COMPLETED-LEARNING") {
        div = (
          <img
            className="state3"
            src={
              i18n.language === 'en'
                ? `${process.env.PUBLIC_URL}/static/images/icon/ic_status_3_tv_th_eng.svg`
                : `${process.env.PUBLIC_URL}/static/images/icon/ic_status_3_tv_th.svg`
            }
            alt=""
          />
        );
      }
    }
    return div;
  };

  const renderStudyDate = () => {
    let div = <div></div>;
    if (list.status === "COMPLETED-LEARNING") {
      div = (
        <div className="days">
          <span>{t("LC_03_05_02.msg003")} : {list.term}</span>
        </div>
      );
      // div = <div className="days"><span>학습기간 : {list.term}</span><span>실제 학습일 : {list.lrnDay} 일</span></div>;
    }
    return div;
  };

  const getAnalysis = () => {
    let data = {};
    setLoading({ isShowSpinner: true, spinnerType: "4" });
    if (props.learner && props.level) {
      http.request({
        url: `${URL.API.COURSE_LEARNING.ANALYSIS}`
          + `/channel/${info.channelCode}`
          + `/language/KO`
          + `/learners/${props.learner}`
          + `/level/${props.level}`,
        method: http.METHOD.POST,
        data,
        success: (res) => {
          for (let i = 0; i < res.prgsByStgList.length; i++) {
            if (res.prgsByStgList[i].prgsCd === "LPSC01") {
              res.prgsByStgList[i].color = "red";
            } else if (res.prgsByStgList[i].prgsCd === "LPSC02") {
              res.prgsByStgList[i].color = "yellow";
            } else if (res.prgsByStgList[i].prgsCd === "LPSC03") {
              res.prgsByStgList[i].color = "green";
            } else if (res.prgsByStgList[i].prgsCd === "LPSC04") {
              res.prgsByStgList[i].color = "purple";
            } else {
              res.prgsByStgList[i].color = "gray";
            }
          }

          let emptyStgListLength = res.totalStgCt - res.prgsByStgList.length;
          let emptyLine = Math.ceil(res.totalStgCt / 5) * 5 - res.totalStgCt;

          for (let i = 0; i < emptyStgListLength; i++) {
            res.prgsByStgList.push({
              cdNm: "zzz",
              color: "gray",
              compStgCd: "",
              prgsCd: "",
              rowNum: res.prgsByStgList.length + 1,
            });
          }

          for (let i = 0; i < emptyLine; i++) {
            res.prgsByStgList.push({
              cdNm: "",
              color: "",
              compStgCd: "",
              prgsCd: "",
              rowNum: "",
            });
          }
          clearLoading();
          setList(res);
        },
        error: (err) => {
          if (err) {
            clearLoading();
          }
        },
      });
    }
  };

  const onChangeFlag = () => {
    props.onChangeFlag(true);
  };

  const openDrillPopUp = (e, flag) => {
    e.stopPropagation();
    setDrillFlag(flag);
  };

  const renderDrillDownPopUp = () => {
    return (
      <div className="tooltip-def type3 tooltipBox active">
        <p>
          {
            t("LC_03_06_lp.msg001").split("<br/>").map((t) => (<><br />{t}</>))
          }
          {list?.drilldwCransrQstCnt}/{list?.drilldwQstCnt}
          <button
            className="btn-closeTooltip btn-close-tooltip"
            onClick={(e) => openDrillPopUp(e, false)}
          ></button>
        </p>
      </div>
    );
  };

  React.useEffect(getAnalysis, [props.level]);
  React.useEffect(() => {
    onChangeFlag();
    setAmplitudeLog({
      eventCategory: 'lms',
      eventName: '실시간학습현황 조회',
    })
  }, []);

  return (
    <>
      <div className="tit_n_state cls">
        <div className="tit tit_blue_16">{list?.lvlNm}</div>
        {
          list?.status && (
            <div className="state_ico">
              {
                info.channelCode !== TYPE.CHANNEL.GLOBAL01 && (
                  <>
                    <span className="hide_t">{setStatus(list?.status, "hide_t")}</span>
                    <span className="hide_pc hide_m">
                      {setStatus(list?.status, "hide_m")}
                    </span>   
                  </>
                )
              }
            </div>
          )
        }
      </div>
      {renderStudyDate()}
      <div className="state_boxes">
        <div className="title">
          <span>{t("LC_03_05_02.msg004")}</span>
        </div>
        <div className="cont">
          <section className="line1">
            <article>
              <div className="tit_area">{t("LC_03_05_02.msg005")}</div>
              <div className="cont_area">
                {list?.solvedQstCnt ? t("LC_03_05_02.msg009", { t: list.solvedQstCnt }) : `0`}
              </div>
            </article>
            <article>
              <div className="tit_area">{t("LC_03_05_02.msg007")}</div>
              <div className="cont_area">
                {list?.rightQstCnt ? t("LC_03_05_02.msg009", { t: list.rightQstCnt }) : `0`}
              </div>
            </article>
            <article onClick={(e) => openDrillPopUp(e, true)}>
              <div className="tit_area">
                {t("LC_03_05_02.msg008")}
                <button className="tip_ico btn-tooltip">
                  <img
                    src={`${process.env.PUBLIC_URL}/static/images/icon/ic_help@2x.png`}
                    alt=""
                  />
                </button>
                {drillFlag && renderDrillDownPopUp()}
              </div>
              <div className="cont_area">
                {list?.drilldwQstCnt ? t("LC_03_05_02.msg009", { t: list.drilldwQstCnt }) : `0`}
              </div>
            </article>
            <article>
              <div className="tit_area">{t("LC_03_05_02.msg010")}</div>
              <div className="cont_area">
                {list?.avgRightCnt ? list?.avgRightCnt : `0`} %
              </div>
            </article>
          </section>
          <section className="line2">
            <article>
              <div className="tit_area">{t("LC_03_05_02.msg011")}</div>
              <div className="cont_area">
                {list?.totalLrnDay ? t("LC_03_05_02.msg012", { d: list?.totalLrnDay }) : `0`}
              </div>
            </article>
            <article>
              <div className="tit_area">{t("LC_03_05_02.msg013")}</div>
              <div className="cont_area">
                {
                  list?.accoumTime 
                  ? (
                    t(
                      "LC_03_05_02.msg014",
                      {
                        h: secondsToMinutes(list.accoumTime).hour,
                        m: secondsToMinutes(list.accoumTime).min
                      }
                    )
                  )
                  : `0`
                }
              </div>
            </article>
            <article>
              <div className="tit_area">{t("LC_03_05_02.msg015")}</div>
              <div className="cont_area">
                {
                  list?.avgSolvTime
                    ? (
                      t(
                        "LC_03_05_02.msg016",
                        {
                          m: secondsToMinutes(list.avgSolvTime).min,
                          s: secondsToMinutes(list.avgSolvTime).sec
                        }
                      )
                    )
                    : `0`
                }
              </div>
            </article>
          </section>
        </div>
      </div>
      <LearningNoteStepState list={list} />
      {/*<LearningNoteStageGrade list={list} />*/}
      {/*<CumulativeLearningRecord list={list} />*/}
    </>
  );
};

export default LearningNoteAnalysis;
